/**
 * Convert a color (hex or rgb) to rgba with given alpha.
 * Used for polygon fill so class color applies with transparency.
 */
export const colorToRgba = (color, alpha = 0.25) => {
  if (!color) return `rgba(0, 0, 255, ${alpha})`;
  const hex = String(color).replace(/^#/, '');
  if (hex.length === 6 && /^[0-9a-fA-F]+$/.test(hex)) {
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
  if (color.startsWith('rgb')) {
    const match = color.match(/\d+/g);
    if (match && match.length >= 3) {
      return `rgba(${match[0]}, ${match[1]}, ${match[2]}, ${alpha})`;
    }
  }
  return `rgba(0, 0, 255, ${alpha})`;
};

/** Parse a hex/rgb color to {r,g,b}; null when it cannot be read. */
export const parseColor = (color) => {
  if (!color) return null;
  const hex = String(color).replace(/^#/, '');
  if (/^[0-9a-fA-F]{3}$/.test(hex)) {
    return {
      r: parseInt(hex[0] + hex[0], 16),
      g: parseInt(hex[1] + hex[1], 16),
      b: parseInt(hex[2] + hex[2], 16),
    };
  }
  if (/^[0-9a-fA-F]{6}$/.test(hex)) {
    return {
      r: parseInt(hex.slice(0, 2), 16),
      g: parseInt(hex.slice(2, 4), 16),
      b: parseInt(hex.slice(4, 6), 16),
    };
  }
  const match = String(color).match(/\d+(\.\d+)?/g);
  if (String(color).startsWith('rgb') && match && match.length >= 3) {
    return { r: Number(match[0]), g: Number(match[1]), b: Number(match[2]) };
  }
  return null;
};

/**
 * Black or white text, whichever stays readable on `color`.
 * Class colors are user data, so the label chip has to adapt to them.
 */
export const readableTextColor = (color) => {
  const rgb = parseColor(color);
  if (!rgb) return '#ffffff';
  // Rec. 709 relative luminance
  const luminance = (0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b) / 255;
  return luminance > 0.62 ? '#0b0c0e' : '#ffffff';
};
